module.exports = __webpack_public_path__ + "img/bar-chart-circle-01.5145b5be.svg";